const menuConfig = [];

export default menuConfig;
